/**
 * Component is used to show order summary promotions on the cart page
 *
 * @param {Array}  [appliedPromotions] - Applied promotions for current order
 *
 * HTML Structure Example
 * <e2-cart-summary-promotions></e2-cart-summary-promotions>
 *
 */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/cart';
import { priceFormatter } from '@elab/core/utils/PriceUtils';

export class CartSummaryPromotions extends SimpleLitElement {
    static get properties() {
        return {
            appliedPromotions: { type: Array },
            showCouponCode: { type: Boolean, attribute: 'show-coupon-code' },
            cssModifier: { type: String, attribute: 'css-modifier' },
            priceSeparator: { type: String, attribute: 'price-separator' },
            isOrderSummary: { type: Boolean, attribute: false },
        };
    }

    constructor() {
        super();

        this.showCouponCode = false;
        this.cssModifier = '';
        this.priceSeparator = '.';
        this.appliedPromotions = [];
        this.isOrderSummary = false;
    }

    getPromotion = ({ amount = {}, message, triggerCouponCode }, i) => {
        const promoValue =
            amount.formattedValue ||
            priceFormatter(amount.value, amount.currencyIso).replace('.', this.priceSeparator);

        const additionalMessage =
            this.showCouponCode && triggerCouponCode ? `${triggerCouponCode}: ` : '';
        const cartOrOrder = this.isOrderSummary ? 'order' : 'cart';
        return html`
            <div class="cart-summary__row cart-summary__promotions ${this.cssModifier}">
                <p class="cart-summary__row-label">${additionalMessage}${message}</p>
                <e2-price-badge
                    store-path="${cartOrOrder}.data.appliedPromotions.${i}.amount.value"
                    currency="${cartOrOrder}.data.appliedPromotions.${i}.amount.currencyIso"
                    additional-class="promotion-price"
                    price-label="-"
                    class="cart-summary__price"
                    price="${promoValue}"
                ></e2-price-badge>
            </div>
        `;
    };

    render() {
        return html`
            ${this.appliedPromotions.map(this.getPromotion)}
        `;
    }
}

const mapStateToProps = state => ({
    appliedPromotions: selectors
        .getPromotions(state)
        .sort((a, b) => a.message.localeCompare(b.message)),
});

export default () =>
    customElements.define(
        'e2-cart-summary-promotions',
        connect(mapStateToProps)(CartSummaryPromotions),
    );
